<p class="header">{{ 'stt.modalEdit.edition' | translate }}</p>
<div class="content">
    <div class="col md-12">
        <div class="titles">
            <ul>
                <li>
                    <p>{{ 'stt.modalEdit.file' | translate }}</p>
                </li>
                <li>
                    <p>{{ 'stt.modalEdit.edit' | translate }}</p>
                </li>
                <li>
                    <p>{{ 'stt.modalEdit.date' | translate }}</p>
                </li>
                <li>
                    <p>{{ 'stt.modalEdit.action' | translate }}</p>
                </li>
            </ul>
        </div>
        <div class="d-flex justify-content-center spinner-content" *ngIf="searching">
            <div class="py-5">
                <mat-spinner [diameter]="70" [strokeWidth]="2"></mat-spinner>
            </div>
        </div>
        <div *ngIf="!searching">
            <div class="list-result" *ngFor="let version of obs | async; let i = index">
                <ul>
                    <li>
                        <p *ngIf="version.versionNumber == 1">Original</p>
                        <p *ngIf="version.versionNumber != 1">{{ version.versionNumber }}</p>
                    </li>
                    <li>
                        <p>{{ version.createdBy }}</p>
                    </li>
                    <li>
                        <p>{{ version.created.substr(0, 10) }}</p>
                    </li>
                    <li>
                        <button class="button-secondary" mat-button [mat-dialog-close]="version.versionNumber">{{ 'stt.modalEdit.watch' | translate }}</button>
                    </li>
                </ul>
            </div>
        </div>
    </div>

    <mat-paginator *ngIf="versionList?.length > 5" #paginator [length]="versionList?.length" [pageIndex]="0" [pageSize]="5"
        [pageSizeOptions]="[10, 20, 40]">
    </mat-paginator>

    <div class="buttons-box">
        <a class="button-primary" mat-dialog-close>{{ 'stt.modalEdit.close' | translate }}</a>
    </div>
</div>